import React from "react";
import "./index.scss";
import {number, oneOf} from "prop-types";
import Title from "features/components/title";
import {__} from "services/i18n";
import VideoCard from "features/components/video-card";
import {DirectoryCard} from "features/components/directory-card";
import {HorizontalScrollSection} from "features/components/horizontal-scroll-section";
import {connect} from "react-redux";
import {getSuggestedStart} from "features/components/suggested/reducer";
import {suggestedDataSelector, suggestedErrorSelector} from "features/components/suggested/selectors";
import {withToastManager} from "react-toast-notifications";
import EventCard from "features/components/event-card";
import ThreadCard from "features/components/thread-card";

/* istanbul ignore next */
const mapStateToProps = state => ({
    dataRaw: suggestedDataSelector(state),
    error: suggestedErrorSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    getSuggestedStart
};
export const SuggestedResource = (props) => {
    const {type, dataRaw, error, resource_id} = props;
    const data = dataRaw[type];
    const {getSuggestedStart} = props;
    React.useEffect(() => {
        getSuggestedStart({type, id: resource_id});
    }, [getSuggestedStart, type, resource_id]);
    React.useEffect(() => {
        if(!error.inError) return;
        //props.toastManager.add(__(error.error), {appearance: "error", id: "suggested-loading-error"});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);
    if(!data || data.length === 0) {
        return null;
    }
    return <div className="suggested">
        <div className="bg" />
        <div className="data">
            <Title size={34}>{__(`suggested.title.${type}`)}</Title>
            <HorizontalScrollSection type={"dark"}>
                {type === "video" && data.map(i => <VideoCard key={i.id} type={"dark"} video={i} />)}
                {type === "directory" && data.map(i => <DirectoryCard key={i.id} directory={i} />)}
                {type === "event" && data.map(i => <EventCard key={i.id} event={i} />)}
                {type === "thread" && data.map(i => <ThreadCard key={i.id} item={i} type={"small"} color={"dark"} />)}
            </HorizontalScrollSection>
        </div>
    </div>
};

SuggestedResource.propTypes = {
    type: oneOf(["video", "directory", "event", "thread"]).isRequired,
    resource_id: number.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(SuggestedResource));